import * as Yup from "yup";
import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";
import { useFormik } from "formik";

import ContainedButton from "components/layout/form/containedButton";
import OutlinedButton from "components/layout/form/outlinedButton";
import TextField from "components/layout/form/textField";
import api from "services/api";
import theme from "styles/theme";
import { UserInfo } from "features/meus-dados";
import { removeSpecialCharacters } from "utils/functions";

import { Container, Form } from "./styles";
import { ContainerButtons, ModalHeader, ModalStyle } from "../styles";

type NameSocialProps = {
  openModal: boolean;
  modalFunction: Dispatch<SetStateAction<boolean>>;
  userInfo: UserInfo;
  setUserInfo: Dispatch<SetStateAction<UserInfo>>;
};

const SocialName = ({
  openModal,
  modalFunction,
  userInfo,
  setUserInfo,
}: NameSocialProps): JSX.Element => {
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    socialName: Yup.string().required("Preencha o nome social"),
  });

  useEffect(() => {
    if (userInfo?.socialName) {
      formik.setFieldValue("socialName", userInfo?.socialName);
    }
  }, [userInfo]);

  const formik = useFormik({
    initialValues: {
      socialName: userInfo?.socialName,
    },
    validationSchema,
    onSubmit: async ({ socialName: socialNameForm }, ctx) => {
      const socialNameFormatted = removeSpecialCharacters(socialNameForm);

      if (socialNameFormatted?.length <= 1) {
        ctx.setFieldError(
          "socialName",
          "É necessário digitar no mínimo 1 caracter válido"
        );

        return;
      }

      const { socialName } = userInfo;

      if (!loading && socialNameFormatted !== socialName) {
        try {
          setLoading(true);
          const headers = {
            access_token: localStorage.getItem(
              "@UltragazEmpresarial:accessToken"
            ),
          };
          const { unitId } = JSON.parse(
            localStorage.getItem("@UltragazEmpresarial:unitData")
          );
          const body = {
            socialName: socialNameFormatted,
            unitId,
          };
          await api.patch(`industrial/customer/v1/customers/me`, body, {
            headers,
          });
          setUserInfo({ ...userInfo, socialName: socialNameFormatted });
          localStorage.setItem(
            "@UltragazEmpresarial:userName",
            socialNameFormatted
          );
          setLoading(false);
          modalFunction(false);
        } catch (err) {
          setLoading(false);
          const erro = err.response;
          if (erro) {
            const { message } = err.response.data;
            if (err.response.status !== 401) {
              toast.error(message);
            }
          } else if (err.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      }
    },
  });

  return (
    <ModalStyle
      show={openModal}
      animation={false}
      centered
      onHide={() => modalFunction(false)}
    >
      <ModalHeader>
        <span>Editar dados</span>
        <MdClose size={24} onClick={() => modalFunction(false)} />
      </ModalHeader>
      <Container>
        <Form onSubmit={formik.handleSubmit}>
          <TextField
            label="Nome Social"
            type="text"
            name="socialName"
            value={formik.values.socialName}
            onBlur={formik.handleBlur}
            errorCondition={
              formik.errors.socialName && formik.touched.socialName
            }
            errorMessage={formik.errors.socialName}
            propsLeadingIcon={{
              size: 25,
            }}
            onChange={formik.handleChange}
          />
          <ContainerButtons>
            <OutlinedButton
              color={theme.colors.purple}
              onClick={() => modalFunction(false)}
            >
              Cancelar
            </OutlinedButton>
            <ContainedButton type="submit" loading={loading}>
              Atualizar
            </ContainedButton>
          </ContainerButtons>
        </Form>
      </Container>
    </ModalStyle>
  );
};

export default SocialName;
